var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import axios from 'axios';
import './interceptor';
var PREFIX = 'themes/api';
var DEFAULT_TIME = 12000;
function formatData(result) {
  var res = Object.create(result);
  while (res.data) {
    res = res.data;
  }
  res = res.body || res;
  return res;
}
function asyncRun(promise, config) {
  if (config === void 0) {
    config = {};
  }
  return __awaiter(this, void 0, void 0, function () {
    var _a, returnResult, _b, throwBizError, result, ret, e_1, error;
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = config.returnResult, returnResult = _a === void 0 ? true : _a, _b = config.throwBizError, throwBizError = _b === void 0 ? false : _b;
          _c.label = 1;
        case 1:
          _c.trys.push([1, 3,, 4]);
          return [4, promise];
        case 2:
          result = _c.sent();
          ret = formatData(result);
          if (throwBizError && ret && ret.ResponseMetadata && ret.ResponseMetadata.Error) {
            throw ret;
          }
          return [2, returnResult && ret.Result || ret];
        case 3:
          e_1 = _c.sent();
          error = e_1;
          throw error;
        case 4:
          return [2];
      }
    });
  });
}
var method = function method(type) {
  return function (options, config) {
    return __awaiter(void 0, void 0, void 0, function () {
      var messageError, axiosConfig, res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            messageError = config.messageError;
            axiosConfig = __assign(__assign({
              timeout: (config === null || config === void 0 ? void 0 : config.timeout) || DEFAULT_TIME
            }, options), {
              method: type,
              messageError: messageError
            });
            return [4, asyncRun(axios(axiosConfig), config)];
          case 1:
            res = _a.sent();
            return [2, res];
        }
      });
    });
  };
};
export var Get = method('get');
export var Post = method('post');
export var Delete = method('delete');
export var Put = method('put');
export function wrapper(Service, prefix) {
  if (prefix === void 0) {
    prefix = PREFIX;
  }
  return function (Action, config) {
    if (config === void 0) {
      config = {};
    }
    return function (params) {
      if (params === void 0) {
        params = {};
      }
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4, Post({
                url: location.origin + "/" + prefix + "/" + Service + "/" + Action,
                data: params,
                headers: {
                  Accept: 'application/json'
                }
              }, config)];
            case 1:
              return [2, _a.sent()];
          }
        });
      });
    };
  };
}
export function getWrapper(Service, prefix) {
  if (prefix === void 0) {
    prefix = PREFIX;
  }
  return function (Action, config) {
    if (config === void 0) {
      config = {};
    }
    return function (params) {
      if (params === void 0) {
        params = {};
      }
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4, Get({
                url: location.origin + "/" + prefix + "/" + Service + "/" + Action,
                params: params,
                headers: {
                  Accept: 'application/json'
                }
              }, config)];
            case 1:
              return [2, _a.sent()];
          }
        });
      });
    };
  };
}